@if (icon) {
  <svg-icon class="mr-1" [src]="icon"></svg-icon>
}

<span
  class="font-main font-bold text-sm text-navy-70 group-hover:text-navy-90 whitespace-nowrap"
  [ngClass]="{ 
    'text-navy-90': isCaretShown,
    'cursor-pointer group-hover:text-navy-90': sortEnabled
  }">
  {{ text | translate }}
</span>

@if (infoTooltipText) {
  <app-info-icon
    class="ml-1 relative top-0.5"
    [tooltipPosition]="'top'"
    [tooltipText]="infoTooltipText | translate">
  </app-info-icon>
}

@if (sortEnabled && isCaretShown) {
  <svg-icon
    data-test-id="sort-caret"
    class="m-1 transform group-hover:visible group-hover:pb-0.5"
    [ngClass]="{
      'rotate-180 pt-0.5': isCaretRotated,
      'pb-0.5': !isCaretRotated,
    }"
    [src]="'caret-down'"
    [stretch]="true">
  </svg-icon>
}
